
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-separator.md?watch=parent';
    export const toc = [{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Stream Separator","toc":"menu","filename":"docs/x-sdk/demos/x-request/stream-separator.md","lastUpdated":1770367868000,"description":"为 XRequest 配置流解析的分隔符 streamSeparator 用于自定义数据流分割方式。"};